import { z } from "zod";

export const editSubjectiveSchema = z.object({
  text: z.string().nonempty("Required"),
});
